import { render, staticRenderFns } from "./DayTemplateSectionActions.vue?vue&type=template&id=74730894&scoped=true&"
import script from "./DayTemplateSectionActions.vue?vue&type=script&lang=js&"
export * from "./DayTemplateSectionActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74730894",
  null
  
)

export default component.exports